import React from 'react';

/**
 * Hero illustration – gradient background with noise effect.
 */
const HeroIllustration: React.FC = () => (
  <div className="hero-illustration" aria-hidden>
    <svg
      className="hero-illustration__svg"
      viewBox="0 0 400 200"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient id="hero-grad-3" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="var(--color-brand-3)" />
          <stop offset="100%" stopColor="var(--color-brand-4)" />
        </radialGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#hero-grad-3)" className="hero-illustration__bg" />
    </svg>
  </div>
);

export default HeroIllustration;
